import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class JobFullDetailsToolsButtonsMarkUnmarkJobAsHasAMajorIssue extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      hasSplitParent: this.props.hasSplitParent || false,
      isSplitJob: this.props.isSplitJob || false,
      hasSplitJobs: this.props.hasSplitJobs || false,
      isSplitJobPartA: this.props.isSplitJobPartA || false,
      isSplitJobPartB: this.props.isSplitJobPartB || false,
      apiUrlForToggleMarkJobAsHasAMajorIssue: "/api/v1/portal/jobs/mark-as/toggle/has-a-major-issue/",
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }

  toggleMarkJobAsHasAMajorIssue() {
    return fetch(
      this.state.apiUrlForToggleMarkJobAsHasAMajorIssue+
      this.state.data.id,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        },
      }
    ).then((responseText) => {
      }
    );
  }

  render() {
    return(
      <span>{(this.state.data.has_a_major_issue !== 1) ?
        <p>Job No issue<br />
          <button
            className="btn btn-lg btn-dark"
            title="Toggle Mark Job as has a major issue"
            onClick={
              (e) => this.toggleMarkJobAsHasAMajorIssue(e)
            }
          >
            Mark Job as Has A Major Issue
          </button></p>
        :
        <p>
          <button className="btn btn-lg row-status-bg-has-a-major-issue">
            Job has a major issue &nbsp;{
            (this.state.data.marked_as_has_a_major_issue_by !== null) ?
              <span>
                      {
                        this.state.data.marked_as_has_a_major_issue_by.first_name+' '+
                        this.state.data.marked_as_has_a_major_issue_by.last_name+
                        ' on '+
                        this.state.data.marked_as_has_a_major_issue_at
                      }
                  </span>
              : ''
          }
          </button>&nbsp;
          <button
            className="btn btn-lg btn-dark"
            onClick={(e) => this.toggleMarkJobAsHasAMajorIssue(e)}
          >
            <i className="fa fa-undo"></i>&nbsp;
            Unmark Job as Has A Major Issue
          </button>
        </p>
      }
    </span>
    )
  }
}